import React, { useEffect, useState } from "react";
import EnterEmailOtp from "./EnterEmailOtp";
import EnterMobileOtp from "./EnterMobileOtp";
import SetPassWord from "./SetPassWord";
import axios from "../../axios";
import { useLocation, useNavigate } from "react-router-dom";

export default function VerifyEmailMobile({
  studentDetails,
  setEmailPhoneVerification,
  emailPhoneVerification,
  setRegister,
  setIsInProgress,
  register,
  inputValue,
  inputSchoolCode,
}) {
  const { verifiedEmail, verifiedMobile } = emailPhoneVerification;
  const [verify, setVerify] = useState({
    verifyEmail: false,
    // verifyMobile: false,
    setPassword: false,
  });
  const [disableButtion, setDisableButtion] = useState(false);
  const navigate = useNavigate();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const header = searchParams.get("unreg");
  const user = searchParams.get("userId");
  const schoolCode = searchParams.get("schoolCode") || "";
  const schoolCodeFromLocal = localStorage.getItem("schoolCode");

  useEffect(() => {
    const disableBackButton = (e) => {
      const searchParams = new URLSearchParams(location.search);
      const unreg = searchParams.get("unreg") || "";
      const userId = searchParams.get("userId") || "";
      const schoolCode = searchParams.get("schoolCode") || "";

      window.history.pushState(
        null,
        document.title,
        `${window.location.href}?unreg=${unreg}&userId=${userId}&schoolCode=${schoolCode}`,
      );
    };

    window.addEventListener("popstate", disableBackButton);

    return () => {
      window.removeEventListener("popstate", disableBackButton);
    };
  }, []);

  const handleEmailOtpVarification = async () => {
    setDisableButtion(true);
    try {
      let response = await axios.post(`/studentAuth/generateEmailOtp`, {
        unique_id: inputValue,
        school_code: inputSchoolCode,
      });
      response && setVerify({ ...verify, verifyEmail: true });
    } catch (error) {
      console.log(error);
    } finally {
      setDisableButtion(false);
    }
  };

  //This is part of verify with mobile no
  // const handlePhoneOtpVarification = async () => {
  //   try {
  //     let response = await axios.post(`/studentAuth/generateMobileOtp`, {
  //       mobile_number: studentDetails?.mobileNumber,
  //     });
  //     response && setVerify({ ...verify, verifyMobile: true });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (header !== "true" || !user) {
      setVerify({ ...verify, setPassword: true });
    } else {
      try {
        await axios.post(`/studentAuth/unregister`, {
          unique_id: user,
          school_code: schoolCode || schoolCodeFromLocal,
        });

        navigate("/unRegSuccessful");
      } catch (error) {
        console.log(error);
      }
    }
  };
  //This method use for hide some part of email
  const MaskedEmail = (email) => {
    const maskEmail = (email) => {
      if (!email || typeof email !== "string") return email;

      const [localPart, domain] = email.split("@");
      if (!localPart || !domain) return email;

      // Mask local part
      const firstPart = localPart.slice(0, 2);
      const maskedLocalMiddle = "*".repeat(Math.max(localPart.length - 4, 5));
      // const lastPart = localPart.slice(-1);

      // Mask domain
      const [domainName, domainExtension] = domain.split(".");
      const maskedDomainMiddle = "*".repeat(Math.max(domainName.length - 2, 3));
      // const firstDomainPart = domainName.slice(0, 1);
      const lastDomainPart = domainName.slice(-1);

      const maskedDomain = `${maskedDomainMiddle}${lastDomainPart}.${domainExtension}`;

      return `${firstPart}${maskedLocalMiddle}@${maskedDomain}`;
    };

    return <spna>{maskEmail(email)}</spna>;
  };

  const maskPhoneNumber = (phone) => {
    if (!phone) return "";

    const phoneStr = phone.toString();

    // Show first 2 and last 2 digits
    return (
      phoneStr.slice(0, 2) +
      "*".repeat(phoneStr.length - 4) +
      phoneStr.slice(-2)
    );
  };

  return (
    <>
      {!verify.setPassword && (
        <div>
          {/* I removed !verify.verifyMobile this is part of verify with mobile no */}

          {!verify.verifyEmail && (
            <div className="ContainerRegister h-100">
              <div className="row">
                <div className="col-md-3 p-0 bannerContainer">
                  <img
                    className="bannerImg"
                    alt="icon"
                    src="/LoginRegister/BannerImg.png"
                  ></img>
                </div>
                <div
                  className="col-md-9 RegisterDetailContainer"
                  style={{ position: "relative" }}
                >
                  <>
                    {/* <div style={{ position: "absolute", top: "15px", left: "25px", cursor: "pointer" }} onClick={() => setRegister((prev) => ({ ...prev, verify: false }))}>
                      <img src="/images/back_arrow.svg" alt="img" />
                    </div> */}
                    <div
                      className="backLoginIcon"
                      onClick={(e) => {
                        setIsInProgress(false);
                        setRegister((prev) => ({ ...prev, verify: false }));
                        setEmailPhoneVerification((prev) => ({
                          ...prev,
                          verifiedEmail: false,
                          verifiedMobile: false,
                        }));
                      }}
                    >
                      <img src="/LoginRegister/LoginBackIcon.png" alt="icon" />
                    </div>

                    <form>
                      <div className="InsideDetailCpntainer">
                        <div className="d-flex justify-content-center">
                          <img
                            className="registrationIcon"
                            src="/StudentImg/BreathSchoolLogo.png"
                            alt="icon"
                          />
                        </div>
                        <div className="d-flex justify-content-center headerRegistration mt-3">
                          {header === "true" ? "Unregister" : "Registration"}
                        </div>
                        <div className=" verifyInputContainer p-3 mt-4">
                          <div className="mb-3">
                            <div className="EmailIdHeader mb-1">
                              Mobile Number
                            </div>

                            <div className="inputBox">
                              <span>
                                +91{" "}
                                {maskPhoneNumber(studentDetails?.mobileNumber)}
                              </span>
                            </div>
                            <span className="text-red-500">
                              {!studentDetails?.mobileNumber &&
                                "Mobile number is not registered!!"}
                            </span>
                          </div>

                          {/* Email */}
                          <div className="mb-3">
                            <div className="EmailIdHeader mb-1">Email ID</div>

                            <div className="inputBox">
                              {MaskedEmail(studentDetails?.email)}

                              {verifiedEmail && (
                                <img
                                  src="/LoginRegister/VerifiedTick.png"
                                  alt="verified"
                                  width={22}
                                />
                              )}
                            </div>
                            <span className="text-red-500">
                              {!studentDetails?.email &&
                                "Email Id is not registered!!"}
                            </span>
                          </div>

                          {/* Verify Button Full Width */}
                          {!verifiedEmail && (
                            <button
                              className={`verify-btn ${
                                disableButtion
                                  ? "cursor-progress"
                                  : "cursor-default"
                              }`}
                              disabled={
                                disableButtion ||
                                (!studentDetails?.email &&
                                  !studentDetails?.mobileNumber)
                              }
                              onClick={handleEmailOtpVarification}
                            >
                              {disableButtion ? "Please wait..." : "Verify Now"}
                            </button>
                          )}
                        </div>
                        <div className="d-flex justify-content-center mt-4">
                          {verifiedEmail && (
                            <button
                              disabled={!verifiedEmail}
                              onClick={handleSubmit}
                              className="RegisterBtn2"
                            >
                              {/* Here I removed verifiedMobile because it is not allow me to set new password */}
                              {verifiedEmail && header === "true"
                                ? "Unregister"
                                : "Continue"}
                            </button>
                          )}
                        </div>
                      </div>
                    </form>
                  </>
                </div>
              </div>
            </div>
          )}
          {verify.verifyEmail && (
            <EnterEmailOtp
              studentDetails={studentDetails}
              setEmailPhoneVerification={setEmailPhoneVerification}
              emailPhoneVerification={emailPhoneVerification}
              setVerify={setVerify}
              setRegister={setRegister}
              setIsInProgress={setIsInProgress}
              inputValue={inputValue}
              inputSchoolCode={inputSchoolCode}
              maskPhoneNumber={maskPhoneNumber}
              MaskedEmail={MaskedEmail}
            />
          )}
          {/* Here I commentend for verify mobile no with opt */}
          {/* {verify.verifyMobile && (
            <EnterMobileOtp
              studentDetails={studentDetails}
              setEmailPhoneVerification={setEmailPhoneVerification}
              emailPhoneVerification={emailPhoneVerification}
              setVerify={setVerify}
              setRegister={setRegister}
              setIsInProgress={setIsInProgress}
            />
          )} */}
        </div>
      )}
      {verify.setPassword && (
        <SetPassWord
          studentDetails={studentDetails}
          setRegister={setRegister}
          setIsInProgress={setIsInProgress}
        />
      )}
    </>
  );
}
